import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import axios from "axios";
import { Header, Footer, Hero, SectionHeader, BlogCard } from "../components/Orchestrio";
import { API } from "../App";
import SEO from "../components/SEO";

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${API}/public/blog`);
        setPosts(response.data);
      } catch (error) {
        console.error("Error fetching posts:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  return (
    <div className="min-h-screen bg-[#0E0E0E]" data-testid="blog-page">
      <SEO 
        title="Blog"
        description="Insights on web development, digital systems, and building maintainable software. From the Orchestrio team."
      />
      <Header />

      {/* Hero Section */}
      <Hero
        marker="Blog"
        title={<>Insights & Ideas</>}
        description="Thoughts on technology, digital transformation, and building better businesses."
      />

      {/* Blog Posts */}
      <section className="section section-bordered">
        <div className="max-w-7xl mx-auto px-6">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3].map((i) => (
                <div key={i} className="bg-[#1C1C1C] border border-[#2E2E2E] animate-pulse">
                  <div className="aspect-video bg-[#2E2E2E]" />
                  <div className="p-6">
                    <div className="h-4 bg-[#2E2E2E] rounded w-1/4 mb-4" />
                    <div className="h-6 bg-[#2E2E2E] rounded w-3/4 mb-3" />
                    <div className="h-4 bg-[#2E2E2E] rounded w-full mb-2" />
                    <div className="h-4 bg-[#2E2E2E] rounded w-2/3" />
                  </div>
                </div>
              ))}
            </div>
          ) : posts.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((post) => (
                <BlogCard
                  key={post.post_id}
                  image={post.featured_image}
                  date={post.published_at}
                  title={post.title}
                  excerpt={post.excerpt}
                  slug={post.slug}
                  tags={post.tags}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-[#8A8A8A] text-lg mb-6">No blog posts yet. Check back soon!</p>
              <Link to="/contact" className="btn-primary inline-flex items-center gap-2">
                Get in Touch <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="section section-dark section-bordered">
        <div className="max-w-xl mx-auto px-6 text-center">
          <SectionHeader 
            marker="Newsletter" 
            title="Stay Updated"
            description="Get the latest insights delivered straight to your inbox."
            centered
          />
          <form className="flex flex-col sm:flex-row gap-4 mt-8">
            <input 
              type="email" 
              placeholder="your@email.com"
              className="input-field flex-1"
            />
            <button type="submit" className="btn-primary whitespace-nowrap">
              Subscribe
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;
